import { forwardRef } from "react";
import type { ComponentProps, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";

type Props = ComponentProps<typeof Box> & {
  label: ReactNode;
  /** Number of active selections; shown as a badge when > 0. */
  activeCount?: number;
};

/** Column-header label + funnel icon + count badge used by the dashboard header filters. */
const HeaderFilterTrigger = forwardRef<HTMLDivElement, Props>(
  function HeaderFilterTrigger({ label, activeCount = 0, sx, ...rest }, ref) {
    return (
      <Box
        ref={ref}
        {...rest}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.35rem",
          cursor: "pointer",
          userSelect: "none",
          ...(sx || {}),
        }}
      >
        {label}
        <FilterAlt
          sx={{ fontSize: "1.1rem", opacity: activeCount ? 1 : 0.7 }}
        />
        {activeCount ? (
          <Typography
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "1.25rem",
              height: "1.25rem",
              px: "0.3rem",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 700,
              lineHeight: 1,
              border: "1px solid",
              borderColor: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              bgcolor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            }}
          >
            {activeCount}
          </Typography>
        ) : null}
      </Box>
    );
  },
);

export default HeaderFilterTrigger;
